import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/contact-us')({
  component: Outlet,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
});
